import { render, staticRenderFns } from "./modalReceitaFarmacia.vue?vue&type=template&id=20e7a556&"
import script from "./modalReceitaFarmacia.vue?vue&type=script&lang=js&"
export * from "./modalReceitaFarmacia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports